import { useEffect, useState } from 'react'
import { getCountryCode } from 'src/business/services'
import {
  EVENT_TEMPLATE_DATA,
  allAvailableEventTypes,
  VISIT_EVENT_TYPES,
} from 'src/consumer/constants'
import { getMPDataWithoutParams } from 'src/mentor/services'
import { getDurationOptions } from 'src/mentor/components/MentorEventsPage/MentorEventsPageStyles'

export default function useEventFormState({
  eventFormModalData,
  oneOnOnePlans,
  basicEventObject: initialEventObject,
  mentorClinicAssociationData,
  mentorProfileData,
}) {
  const [selectedPanelMembers, setSelectedPanelMembers] = useState([])
  const [loadingPanelMembers, setLoadingPanelMembers] = useState(true)
  const [isCustomTimeChosen, setIsCustomTimeChosen] = useState(false)
  const [viewPriceCountry, setViewPriceCountry] = useState()
  const [showAddCustomPrice, setShowAddCustomPrice] = useState(false)
  const [oneOnOnePlanToEdit, setOneOnOnePlanToEdit] = useState()
  const [bundlePackToEdit, setBundlePackToEdit] = useState()
  const [showBundlePackEditModal, setShowBundlePackEditModal] = useState(false)

  const eventTemplateData = {
    ...EVENT_TEMPLATE_DATA,
    subscriptionPlanId: oneOnOnePlans?.[0]?.id,
  }

  const [basicEventObject, setBasicEventObject] = useState(
    eventFormModalData ? { ...eventFormModalData } : eventTemplateData,
  )

  async function Setup() {
    const currentCountryCode = getCountryCode() || 'IN'
    setViewPriceCountry(currentCountryCode.toLowerCase())
    setLoadingPanelMembers(true)
    const response = await getMPDataWithoutParams(
      `/api/secure/teacher/other-teachers/list?ids=${basicEventObject?.panelIds?.join(',')}`,
    )
    if (response.status === 200) {
      const toSet = basicEventObject?.panelIds?.map((id) => {
        const foundTeacher = response.data.find((teacher) => teacher.id === id) || {
          id: id,
          name: 'Error',
        }
        return foundTeacher
      })
      setSelectedPanelMembers(toSet)
    }
    setLoadingPanelMembers(false)
  }

  function changeLocationBasedOnMentorOrClinicLocation(locationObject, contextId) {
    const contextIdToUse = contextId
    if (contextIdToUse) {
      const foundClinic = mentorClinicAssociationData?.find(
        (clinic) => clinic?.id === contextIdToUse,
      )
      setBasicEventObject((prev) => ({
        ...prev,
        location: locationObject ? locationObject : foundClinic.location,
      }))
    } else {
      setBasicEventObject((prev) => ({
        ...prev,
        location: locationObject ? locationObject : mentorProfileData?.location,
      }))
    }
  }

  useEffect(() => {
    changeLocationBasedOnMentorOrClinicLocation(
      basicEventObject?.location,
      basicEventObject?.contextId,
    )
  }, [mentorClinicAssociationData, mentorProfileData])

  useEffect(() => {
    Setup()
  }, [])

  useEffect(() => {
    const allDurations = getDurationOptions()
    if (
      !allDurations?.some(
        (item) => parseInt(item?.props?.value) === basicEventObject?.durationInMins,
      )
    ) {
      setIsCustomTimeChosen(true)
    }
  }, [])

  return {
    // State
    basicEventObject,
    setBasicEventObject,
    selectedPanelMembers,
    setSelectedPanelMembers,
    loadingPanelMembers,
    setLoadingPanelMembers,
    isCustomTimeChosen,
    setIsCustomTimeChosen,
    viewPriceCountry,
    setViewPriceCountry,
    showAddCustomPrice,
    setShowAddCustomPrice,
    oneOnOnePlanToEdit,
    setOneOnOnePlanToEdit,
    bundlePackToEdit,
    setBundlePackToEdit,
    showBundlePackEditModal,
    setShowBundlePackEditModal,
    // Functions
    changeLocationBasedOnMentorOrClinicLocation,
  }
}
